// SelexMBLanding.jsx

import React, { useState } from "react";

import {
  Box,
  Typography,
  Button,
  Chip,
  Modal,
  TextField,
  Paper,
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PsychologyIcon from "@mui/icons-material/Psychology";
import InsightsIcon from "@mui/icons-material/Insights";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import HubIcon from "@mui/icons-material/Hub";
import VerifiedIcon from "@mui/icons-material/Verified";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import { useNavigate,useLocation } from "react-router-dom";


import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import BgContainer2 from "./CommonC/BgContainer2";
import selexlogo from "../images/SelexMB Final.png";
import ichemeAwardBadge from "../images/products/icheme-global-awards-highly-commended-2024.png";
import { baseURL } from "../Config/config";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ExploreIcon from "@mui/icons-material/Explore";
import Footer from "./Footer";
import selexmbplus from "../images/products/selexmbplus.png";
import selexmbplus1 from "../images/products/selexmbplus1.png";
import selexmbexplorer1 from "../images/products/selexmbexplorer1.png";


import selexstudio from "../images/products/selexstudio.png";
import selexstudiovideo from "../images/products/SelexStudio.mp4";
import selexstudio1 from "../images/products/selexstudio1.png";





const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

const apps = [
  {
    name: "SelexMB Plus",
    route: "/home",
    logo: selexmbplus,
    tag: "AI + first-principles",
    desc: "Build dynamic mathematical models, perform simulations, and solve engineering systems with advanced computational tools.",
    challenges:["Key quality and conversion variables can’t be measured online lab results lag operations by hours.​","Operators run conservatively inside limits, leaving throughput, yield and energy on the table.​","Pure physics models are too rigid to track real plant behaviour shift to shift.​"],
    values :["Real-time soft sensors reveal unmeasured quality and performance instantly.​","Forecasts process drift before limits are breached, enabling proactive moves.​","Live optimization pushes units to true constraints more throughput, less energy.​"],
    descimg:selexmbplus1
  },
  {
    name: "SelexMB Explorer",
    route: "/selexmbexplorer",
    logo: selexmbplus,
    tag: "Dynamic Optimization",
    desc: "Analyze process dynamics, optimize operational efficiency, and visualize performance trends through intelligent simulations.",
    challenges :["Years of historian and lab data sit unused; root causes stay hidden.​","Diagnosing an upset means weeks of manual data wrangling across teams.​","Engineers can’t safely test operating changes on the live plant.​"],
    values :["Rapidly surfaces the real drivers of yield, quality and upsets.​","Test what-if changes offline in minutes zero plant risk.​","Turns raw history into models that feed soft sensors and optimization.​"],
    descimg:selexmbexplorer1
  },
  {
    name: "SelexStudio",
    route: "/selexstudio/v3-0xp",
    logo: selexstudio,
    tag: "AI Digital-Twin",
    desc: "AI Digital-Twin platform to build, live plant models, layered with performance monitoring, soft sensors with ability to provide an open-loop optimizer",
    challenges :["A plant digital twin normally needs specialist teams and long projects.​","Models built once are rarely kept live, so optimization value decays.​","Operators lack an easy advisory linking models to daily decisions.​"],
    values :["Build, train and deploy living plant digital twins without a specialist team.​","Open-loop optimizer turns models into actionable operating recommendations.​","Keeps the twin live so optimization value is sustained, not one-off.​"],
    descimg:selexstudio1
  },
]


function SelexMBLanding() {

  const [demoOpen, setDemoOpen] = useState(false);
  const [openAppModal, setOpenAppModal] = React.useState(false);
  const [selectedApp, setSelectedApp] = React.useState(null);
  const navigate = useNavigate();
   const location = useLocation();

  
    const [demoForm, setDemoForm] = React.useState({
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
    });
    
    const isLoggedIn = !!sessionStorage.getItem("usertoken");
      const handleDemoChange = (e) => {
    setDemoForm({
      ...demoForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleAppClick = (app) => {
  setSelectedApp(app);
  setOpenAppModal(true);
};

const handleCloseAppModal = () => {
  setOpenAppModal(false);
  setSelectedApp(null);
};
  
const handleDemoSubmit = async () => {
  try {
    const response = await fetch(`${baseURL}/request-demo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...demoForm,
        to: "safiyanaaz@optimizegs.com",
      }),
    });

    if (response.ok) {
      alert("Demo Request for SelexMB Submitted Successfully");
      setDemoOpen(false)
    } else {
      alert("Failed to submit request");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");

  }
};

  const workflowSteps = [
    {
      title: "Import Data",
      icon: <CloudDoneIcon />,
      desc: "Import industrial process and operational datasets from multiple sources.",
    },

    {
      title: "Define KPI",
      icon: <InsightsIcon />,
      desc: "Configure KPIs, dependent variables and engineering objectives.",
    },

    {
      title: "Data Reconditioning",
      icon: <HubIcon />,
      desc: "Prepare, clean and transform datasets for intelligent modeling.",
    },

    {
      title: "Model Building",
      icon: <PsychologyIcon />,
      desc: "Build AI, regression, forecasting and hybrid first-principles models.",
    },

    {
      title: "Model Validation",
      icon: <VerifiedIcon />,
      desc: "Validate models with accuracy metrics, error analysis and diagnostics.",
    },

    {
      title: "Model Deployment",
      icon: <AutoGraphIcon />,
      desc: "Deploy ML models for prediction, optimization and real-time monitoring.",
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "#fff",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <SelexSolNavbar
        isLoggedIn={!!sessionStorage.getItem("usertoken")}
      />

       <Box
              sx={{
                width: "min(1280px, calc(100% - 32px))",
                mx: "auto",
                pt: { xs: 15, md: 18 },
                pb: 8,
              }}
            >
      {/* HERO */}
      <Box
        sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: 4,
            alignItems: "center",
            mb: { xs: 6, md: 8 },
          }}
      >
       
          {/* LEFT */}
          <Box>
            <Box
                                  component="img"
                                  src={selexlogo}
                                  sx={{ width: 125, maxHeight: 125, objectFit: "contain" }}
                                />
                        
            

             <Typography
                          component="h1"
                          sx={{
                            fontSize: { xs: 40, sm: 54, md: 72 },
                lineHeight: 0.96,
                fontWeight: 950,
                letterSpacing: { xs: "-1.8px", md: "-3.4px" },
                color: navy,
                mb: 2,
                mt:2
                          }}
                        >
                          Explore AI and Modeling Intelligence <Box component="span" sx={{ color: primary }}>Selex</Box>
                          <Box component="span" sx={{ color: accent }}>MB™</Box> apps
                        </Typography>

            <Typography
              sx={{
                fontSize: { xs: 15, md: 18 },
                color: "#000",
                lineHeight: 1.8,
                maxWidth: 750,
                mb: 3.5,
              }}
            >
              AI + first-principles engine that builds soft sensors,
              forecasts process behavior, dynamically optimizes
              operations and captures complex industrial phenomena
              to support faster, data-driven engineering decisions.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
             
             

              <Button
                onClick={() => setDemoOpen(true)}
                sx={{
                  px: 4,
                  py: 1.4,
                  borderRadius: "16px",
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: 15,
                  border: `1px solid ${primary}`,
                  color: primary,

                  "&:hover": {
                    borderColor: accent,
                    color: accent,
                    bgcolor: "rgba(158,11,34,0.04)",
                  },
                }}
              >
                Request Demo
              </Button>
            </Box>
          </Box>

          {/* RIGHT OVERVIEW */}
          <Box
            sx={{
              position: "relative",
              borderRadius: "34px",
              p: { xs: 3, md: 4 },

              background:
                "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",

              overflow: "hidden",

              border: "1px solid rgba(0,120,201,0.16)",

              boxShadow:
                "0 24px 60px rgba(0,120,201,0.10)",

              
              
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Typography
                sx={{
                  fontSize: 14,
                  color: accent,
                  fontWeight: 800,
                  mb: 1,
                  letterSpacing: 1,
                }}
              >
                PLATFORM COVERAGE
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 34, md: 46 },
                  fontWeight: 950,
                  lineHeight: 1,
                  mb: 3,
                  color: primary,
                }}
              >
                AI + MLOps Ecosystem
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5 }}>
                {[
                  [
                    "Soft Sensors",
                    "Build predictive soft sensors and AI-assisted virtual measurements.",
                  ],

                  [
                    "Forecasting",
                    "Predict future operational behavior using advanced ML models.",
                  ],

                  [
                    "Dynamic Optimization",
                    "Run intelligent optimization and what-if operational scenarios.",
                  ],
                ].map(([title, desc]) => (
                  <Box
                    key={title}
                    sx={{
                      p: 2,
                      borderRadius: "18px",

                      background:
                        "linear-gradient(135deg, rgba(255,255,255,0.92), rgba(248,251,255,0.88))",

                      border:
                        "1px solid rgba(0,120,201,0.12)",

                      boxShadow:
                        "0 10px 28px rgba(0,120,201,0.06)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 900,
                        color: primary,
                        mb: 0.4,
                        fontSize: 16,
                      }}
                    >
                      {title}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#000",
                        lineHeight: 1.6,
                      }}
                    >
                      {desc}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        
      </Box>

       {/* SECTION TITLE */}
              <Box sx={{ textAlign: "center", mb: 4 }} id="apps">
                <Typography
                  sx={{
                    color: accent,
                    fontSize: 12,
                    fontWeight: 950,
                    letterSpacing: 1.2,
                    textTransform: "uppercase",
                    mb: 1,
                  }}
                >
                  Applications
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 28, md: 42 },
                    fontWeight: 950,
                    color: navy,
                    letterSpacing: "-1.4px",
                    mb: 1.5,
                  }}
                >
                  Select a SelexMB™ solution
                </Typography>
                <Typography sx={{ color: "#64748b", maxWidth: 760, mx: "auto", lineHeight: 1.75,fontSize:14 }}>
                  Choose the application that fits your simulation, optimization, process monitoring, or AI inferential workflow.
                </Typography>
              </Box>
      
              {/* APPS GRID */}
             <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            lg: "repeat(3, 1fr)",
          },
          gap: 3,
        }}
      >
        {apps.map((app, index) => (
          <Box
            key={app.name}
            onClick={() => handleAppClick(app)}
            sx={{
              textDecoration: "none",
              position: "relative",
              minHeight: 300,
              p: 3,
              borderRadius: "30px",
              cursor: "pointer",
              overflow: "hidden",
      
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",
      
              border: "1px solid rgba(0,120,201,0.16)",
      
              boxShadow: "0 18px 48px rgba(0,120,201,0.10)",
      
              transition: "0.35s ease",
      
              "&:hover": {
                transform: "translateY(-10px)",
                boxShadow: "0 28px 75px rgba(0,120,201,0.18)",
                borderColor: primary,
              },
      
            
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    width: 76,
                    height: 76,
                    borderRadius: "22px",
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid rgba(0,120,201,0.12)",
                    boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
                  }}
                >
                  <Box
                    component="img"
                    src={app.logo}
                    alt={app.name}
                    sx={{
                      width: 52,
                      maxHeight: 52,
                      objectFit: "contain",
                    }}
                  />
                </Box>
      
               
              </Box>
      
              <Chip
                label={app.tag}
                size="small"
                sx={{
                  bgcolor: "rgba(158,11,34,0.08)",
                  color: accent,
                  border: "1px solid rgba(158,11,34,0.12)",
                  fontWeight: 800,
                  mb: 2,
                  fontSize:12
                }}
              />
      
              <Typography
                sx={{
                  fontSize: 24,
                  fontWeight: 950,
                  color: primary,
                  mb: 1.2,
                }}
              >
                {app.name}
              </Typography>
      
              <Typography
                sx={{
                  fontSize: 14,
                  color: "#64748b",
                  lineHeight: 1.75,
                  mb: 3,
                }}
              >
                {app.desc}
              </Typography>
      
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.8,
                  color: primary,
                  fontWeight: 900,
                  fontSize: 14,
                }}
              >
                About <ArrowForwardIcon sx={{ fontSize: 17 }} />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      
              <Modal open={openAppModal} onClose={handleCloseAppModal}>
  <Box
    sx={{
      width: { xs: "92%", md: 1600 },
      bgcolor: "#fff",
      borderRadius: "18px",
      p: 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "0px 22px 65px rgba(6,29,52,0.22)",
      //border: "1px solid rgba(0,120,201,0.18)",
      overflow: "hidden",
    }}
  >
    {selectedApp && (
      <>
        {/* TOP BAR */}
        <Box
          sx={{
            height: 18,
            background: "linear-gradient(90deg,#061d34,#0078c9)",
          }}
        />

        <Box
          sx={{
            p: { xs: 2.5, md: 4 },
            display: "grid",
            gridTemplateColumns: {
  xs: "1fr",
  md: "250px 360px 1fr",
},
            gap: 3,
          }}
        >
          {/* LEFT PRODUCT CARD */}
          <Box component={Paper}
          elevation ={0} sx={{borderRadius: "18px"}}>
            <Box
              sx={{
                borderRadius: "18px",
                //border: "1px solid rgba(0,120,201,0.14)",
                overflow: "hidden",
                boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
                height:"470px",
              }}
            >
            <Typography
              sx={{
                fontSize: { xs: 24, md: 24 },
                fontWeight: 950,
                color: "#fff",
                background:"#0078c9",
                mb: 2.5,
                px: 2,
                  py: 1.2,
              }}
            >
              {selectedApp.name}
            </Typography>
             

              <Box sx={{ p: 2.5 }}>
                <Box
                  sx={{
                    width: 76,
                    height: 76,
                    borderRadius: "50%",
                    bgcolor: "#f8fbff",
                    border: "1px solid #d9e9f7",
                    display: "grid",
                    placeItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={selectedApp.logo}
                    alt={selectedApp.name}
                    sx={{
                      width: 52,
                      maxHeight: 52,
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#0078c9",
                    fontWeight: 800,
                    mb: 1,
                  }}
                >
                  {selectedApp.tag}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#061d34",
                    lineHeight: 1.7,
                    fontStyle: "italic",
                  }}
                >
                  {selectedApp.desc}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* RIGHT CONTENT */}
          <Box
          component={Paper}
          elevation ={1}
          sx={{height:"470px",border:"1px solid #fff",borderRadius: "14px"}}
          >
            

            {/* INDUSTRIAL CHALLENGES */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                mb: 2,
                //border: "1px solid rgba(158,11,34,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#b42325",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Industrial Challenges
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.challenges).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* VALUE PROPOSITION */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                //border: "1px solid rgba(0,120,201,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#2878bd",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Product Value Proposition
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.values).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>

          <Box>
             {selectedApp.descimg?.endsWith(".mp4") ? (
  <Box
    component="video"
    src={selectedApp.descimg}
    controls
    autoPlay
    muted
    loop
    sx={{
      width: 900,
      height: "470px",
      objectFit: "contain",
    }}
  />
) : (
  <Box
    component="img"
    src={selectedApp.descimg}
    alt={selectedApp.name}
    sx={{
      width: 900,
      height: "470px",
      objectFit: "contain",
    }}
  />
)}


 {/* FOOTER ACTIONS */}
        <Box
          sx={{
            px: { xs: 2.5, md: 4 },
            py: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            borderTop: "1px solid rgba(0,120,201,0.10)",
            background: "#f8fbff",
          }}
        >
          <Button
            onClick={handleCloseAppModal}
            variant="outlined"
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 700,
              color: "#0078c9",
              borderColor: "#0078c9",
              "&:hover": {
                borderColor: "#9e0b22",
                color: "#9e0b22",
              },
            }}
          >
            Close
          </Button>

          {isLoggedIn?  (
            <Button
              component="a"
              href={selectedApp.route}
              variant="contained"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "12px",
                fontWeight: 700,
                background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
                "&:hover": {
                  background: "#9e0b22",
                  color: "#fff",
                },
              }}
            >
              Go to {selectedApp.name} App
            </Button>
          ):(
            <Button
             onClick={() =>
    navigate("/login", {
      state: { from: selectedApp.route }
    })
  }
              sx={{
                width: 140,
                height: 44,
                borderRadius: "14px",
                background: "linear-gradient(135deg, #005da0, #005da0)",
                color: "#fff",
                transition: "0.3s",
                textTransform: "none",
                fontWeight: 700,
                fontSize:14,
          
                "&:hover": {
                  background: "#9e0b22",
                  color: "#fff",
                  transform: "translateY(-2px)",
                },
              }}
            >
              Login
            </Button>
          )
          }
        </Box>
        </Box>

       
      
        </Box>

      </>
    )}
    </Box>
</Modal>

      {/* IChemE RECOGNITION */}
      <Box
        sx={{
          mb: { xs: 7, md: 9 },
          p: { xs: 3, md: 4 },
          mt:5,
          borderRadius: "30px",
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",
          border: "1px solid rgba(0,120,201,0.16)",
          boxShadow: "0 18px 48px rgba(0,120,201,0.10)",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "220px 1fr" },
          gap: { xs: 3, md: 4 },
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={ichemeAwardBadge}
          alt="IChemE Global Awards Highly Commended 2024"
          sx={{
            width: { xs: 170, md: 200 },
            maxWidth: "100%",
            mx: { xs: "auto", md: 0 },
            display: "block",
            objectFit: "contain",
          }}
        />

        <Box>
          <Typography
            sx={{
              color: accent,
              fontSize: 12,
              fontWeight: 950,
              letterSpacing: 1.2,
              textTransform: "uppercase",
              mb: 1,
            }}
          >
            Recognition
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 28, md: 38 },
              fontWeight: 950,
              color: navy,
              letterSpacing: "-1px",
              mb: 1.5,
            }}
          >
            IChemE Global Awards 2024 – Highly Commended
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 14, md: 16 },
              color: "#000",
              lineHeight: 1.8,
              maxWidth: 900,
            }}
          >
            SelexMB™ received a Highly Commended recognition at the IChemE Global Awards 2024.
            This recognition highlights the platform’s contribution to engineering innovation through
            the integration of first-principles modelling, artificial intelligence, predictive analytics
            and optimization to support more informed and efficient industrial decision-making.
          </Typography>
        </Box>
      </Box>

      {/* WORKFLOW */}
      <Box
        sx={{
          px: { xs: 3, md: 8 },
          pb: 10,
          mt:2
        }}
      >
        <Typography
          sx={{
            fontSize: 42,
            fontWeight: 950,
            color: "#061d34",
            mb: 1,
            textAlign: "center",
          }}
        >
          MLOps Workflow
        </Typography>

        <Typography
          sx={{
            fontSize: 16,
            color: "#64748b",
            textAlign: "center",
            mb: 6,
          }}
        >
          Complete 6-step industrial AI lifecycle
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              lg: "repeat(3, 1fr)",
            },
            gap: 3,
          }}
        >
          {workflowSteps.map((step, index) => (
            <Paper
              key={step.title}
              elevation={0}
              sx={{
                p: 3,
                borderRadius: "28px",

                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",

                border:
                  "1px solid rgba(0,120,201,0.14)",

                boxShadow:
                  "0 16px 42px rgba(0,120,201,0.08)",

                transition: ".35s",

                "&:hover": {
                  transform: "translateY(-8px)",
                  borderColor: primary,
                  boxShadow:
                    "0 24px 58px rgba(0,120,201,0.14)",
                },
              }}
            >
              <Box
                sx={{
                  width: 62,
                  height: 62,
                  borderRadius: "18px",

                  background:
                    "linear-gradient(135deg,#0078c9,#0d8fe6)",

                  display: "grid",
                  placeItems: "center",

                  color: "#fff",

                  mb: 2,

                  boxShadow:
                    "0px 12px 28px rgba(0,120,201,0.22)",

                  "& svg": {
                    fontSize: 30,
                  },
                }}
              >
                {step.icon}
              </Box>

              <Typography
                sx={{
                  fontSize: 22,
                  fontWeight: 900,
                  color: primary,
                  mb: 1,
                }}
              >
                {index + 1}. {step.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: 14,
                  color: "#000",
                  lineHeight: 1.8,
                }}
              >
                {step.desc}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>


      {/* DEMO MODAL */}
       <Modal open={demoOpen} onClose={() => setDemoOpen(false)}>
                <Box
                  sx={{
                    width: 430,
                    bgcolor: "#fff",
                    borderRadius: "26px",
                    p: 3,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 18px 55px rgba(6,29,52,0.18)",
                    border: "1px solid rgba(0,120,201,0.14)",
                  }}
                >
                  <Typography sx={{ fontSize: 22, fontWeight: 900, color: "#0078c9", mb: 1 }}>
                    Request Demo
                  </Typography>
              
                  <Typography sx={{ fontSize: 14, color: "#64748b", mb: 2 }}>
                    Fill your details and our team will contact you.
                  </Typography>
              
                  {[
                    { label: "Full Name", name: "name" },
                    { label: "Business Email", name: "email" },
                    { label: "Phone", name: "phone" },
                    { label: "Company", name: "company" },
                    { label: "Product", name: "product" },
                    { label: "Message", name: "message", multiline: true },
                  ].map((field) => (
                    <TextField
                      key={field.name}
                      fullWidth
                      size="small"
                      label={field.label}
                      name={field.name}
                      multiline={field.multiline}
                      rows={field.multiline ? 3 : 1}
                      value={demoForm[field.name]}
                      onChange={handleDemoChange}
                      sx={{
                        mb: 1.5,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          fontSize: "14px",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "13px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d9e9f7",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#9e0b22",
                        },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#0078c9",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#0078c9",
                        },
                      }}
                    />
                  ))}
              
                  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
                    <Button
                      onClick={() => setDemoOpen(false)}
                      variant="outlined"
                      sx={{
                        borderRadius: "12px",
                        textTransform: "none",
                        color: "#0078c9",
                        borderColor: "#0078c9",
                        fontSize:"14px",
                      }}
                    >
                      Cancel
                    </Button>
              
                    <Button
                      onClick={handleDemoSubmit}
                      variant="contained"
                      sx={{
                        borderRadius: "12px",
                        fontSize:"14px",
                        textTransform: "none",
                        background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                        boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
                        "&:hover": {
                          background: "#9e0b22",
                        },
                      }}
                    >
                      Send Request
                    </Button>
                  </Box>
                </Box>
              </Modal>
              </Box>
      <Footer />
    </Box>
  );
}

export default SelexMBLanding;